import { useState, MouseEvent, useEffect } from 'react';
import { useLocation } from 'react-router';
import { useIntl } from 'react-intl';

// material-ui
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

// assets
import { Card, Edit2, Logout } from 'iconsax-reactjs';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

interface Props {
  handleLogout: () => void;
}

export default function ProfileTab({ handleLogout }: Props) {
  const { pathname } = useLocation();
  const intl = useIntl();

  const [selectedIndex, setSelectedIndex] = useState<number>();
  const handleListItemClick = (_event: MouseEvent<HTMLDivElement>, index: number) => {
    setSelectedIndex(index);
  };

  useEffect(() => {
    const pathToIndex: { [key: string]: number } = {};
    setSelectedIndex(pathToIndex[pathname] ?? undefined);
  }, [pathname]);

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      <ListItemButton
        selected={selectedIndex === 0}
        onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 0)}
      >
        <ListItemIcon>
          <Edit2 variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary={intl.formatMessage({ id: 'profile.editProfile' })} />
      </ListItemButton>
      <ListItemButton
        selected={selectedIndex === 1}
        onClick={(event: MouseEvent<HTMLDivElement>) => handleListItemClick(event, 1)}
      >
        <ListItemIcon>
          <Card variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary={intl.formatMessage({ id: 'profile.billings' })} />
      </ListItemButton>
      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <Logout variant="Bulk" size={18} />
        </ListItemIcon>
        <ListItemText primary={intl.formatMessage({ id: 'profile.logout' })} />
      </ListItemButton>
    </List>
  );
}
